<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-25 md-small-size-100" v-if="hasCheckBox">
      <md-checkbox v-model="data.allow_student_family">{{
        $t("communication.also_send_to_students_family")
      }}</md-checkbox>
    </div>
    <div
      class="md-layout-item md-size-25 md-small-size-100"
      :key="selectedIndex"
    >
      <selection-component
        label="communication.student_name_student_id"
        :data-list="dataList"
        :display-field="displayField"
        :track-by="trackBy"
        @update-selections="updateSelectionsData"
        @filtering="filterStdUsn"
        ref="selectionsRef"
      ></selection-component>
    </div>
  </div>
</template>
<script>
import { service_paths } from "@/constants/Services";
import SelectionComponent from "./../Selections";
import { getId } from "@/helpers/utils";
import { mapState } from "vuex";
export default {
  name: "FilterCounselor",
  components: {
    SelectionComponent
  },
  props: ["data", "hasCheckBox"],
  data() {
    return {
      selectedIndex: 0,
      trackBy: "_id",
      displayField: "full_name",
      currentPath: "",
      dataList: [],
      gradeList: [],
      delayTime: null,
      query: {
        limit: 100,
        fields: ["full_name", "student_code"]
      }
    };
  },
  computed: {
    ...mapState("user", ["info"])
  },
  created() {
    this.currentPath = `${service_paths.users}/${getId(
      this.info
    )}/assigned-students`;
    this.getDataList();
  },
  methods: {
    filterStdUsn(usnQuery) {
      this.query = {
        ...this.query,
        key_search: usnQuery
      };
      clearTimeout(this.delayTime);
      this.delayTime = setTimeout(() => {
        this.$axios.get(this.currentPath, this.query).then(response => {
          this.dataList = response.data.data;
          const memorizedSelected = this.$refs.selectionsRef.getMemorizedSelected();
          memorizedSelected.forEach(studentSelected => {
            if (!this.dataList.includes(studentSelected))
              this.dataList.push(studentSelected);
          });
        });
      }, 200);
    },
    getDataList() {
      this.$axios.get(this.currentPath, this.query).then(response => {
        this.dataList = response.data.data;
      });
    },
    updateSelectionsData(e) {
      this.data.selectedList = e;
    }
  }
};
</script>
